module.exports = __webpack_public_path__ + "img/download.79f5ab51.svg";